import { css } from 'styled-system/css';
import googleSheetIcon from '../../../assets/google-sheet-icon.svg';

export function GoogleSheetsMark() {
  return (
    <img
      src={googleSheetIcon}
      width={32}
      height={23}
      alt=""
      draggable={false}
      aria-hidden="true"
      className={css({
        display: 'block',
        marginBottom: '6',
      })}
    />
  );
}
